import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import EffectType from "@/effects/EffectType"
import { Personality } from "@/employee/Personality"

export class CuddlyPersonality extends Personality {
    id: string = 'cuddly'
    affix: string = 'prefix'

    description(): string {
      return `Cuddly characters love cuddling often, and gain sexual satisfaction from it.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "cuddleDelay": [new ValueMod(0.5, 'mul')],
        "cuddleDuration": [new ValueMod(1, 'mul')],
        "cuddleLust": [new ValueMod(0, 'mul')] // We override default and use our own in onCuddle
      }
    }

    onCuddle(employee: Employee) {
      employee.effectManager.addTempEffect(
        'cuddly-cuddle',
        'mood',
        new ValueMod(10, 'add'),
        new EffectType(employee.constants["cuddleDuration"], 'instant', 'temporary')
      )

      employee.effectManager.addTempEffect(
        'cuddly-satisfaction',
        'lust',
        new ValueMod(-10, 'add'),
        new EffectType(employee.constants["cuddleDuration"], 'instant', 'temporary')
      )

      employee.lust.addValue(-10)
    }
}
